import { render, staticRenderFns } from "./OnlineAppointmentTreatmentSetting.vue?vue&type=template&id=450db919&scoped=true"
import script from "./OnlineAppointmentTreatmentSetting.vue?vue&type=script&lang=js"
export * from "./OnlineAppointmentTreatmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450db919",
  null
  
)

export default component.exports